(function () {
  'use strict';
  angular.module('vcpatdocs')
    .component('newaide', {
      restrict: 'E',
      bindings: {
        consultid: '<?',
        patientid: '<?',
        mode: '@?',
        modal: '<?'
      },
      templateUrl: 'vcpatdocs/newaide-smartcomponent.tpl.html',
      controllerAs: 'vm',
      controller: ['$log', 'Patdocs', 'ClientHelper', 'Config', 'Rlog', '$timeout', 'PrintHelper',
        function ($log, Patdocs, ClientHelper, Config, Rlog, $timeout, PrintHelper) {
          let vm = this;
          vm.saveDoctor = saveDoctor;
          vm.clearDoctor = clearDoctor;

          vm.savePatient = savePatient;
          vm.clearPatient = clearPatient;

          vm.loadValues = loadValues;
          vm.toggleGroup = toggleGroup;
          vm.joinValues = joinValues;
          vm.flattenArray = flattenArray;
          vm.setRefDate = setRefDate;

          vm.add = add;
          vm.cancel = cancel;
          vm.print = print;

          vm.options = {updateOn: 'default blur', debounce: {default: 20000, blur: 0}};


          vm.$onInit = function () {
            vm.mode = 'patient';
            initNewRef();

            vm.labreset = 0;
            vm.imagingreset = 0;

            vm.standalone = angular.isUndefined(vm.patientid) && angular.isUndefined(vm.consultid);

            //  get labvalues and groups from config
            Config.$find('aideconfiguration').$then(aideconfig => {
              vm.aideconfig = aideconfig;
            }, error => {
              Rlog.error('patdocs', 'newaide', 'aideconfiguration.$find() failed', {id: vm.patientid});
              $log.error('aideconfiguration.$find() failed', error);
            });


          }; // $onInit()


          // vm.patientid, consultid might be late propagating, get them on first real change
          vm.$onChanges = function (changes) {
            if (!changes.isFirstChange) {
              if (angular.isDefined(changes.patientid) && angular.isString(changes.patientid.currentValue) && changes.patientid.currentValue.length > 0) {
                vm.patientid = changes.patientid.currentValue;
                // get client/patient information for inclusion inside document
                ClientHelper.find(vm.mode, vm.patientid).$then(function (patient) {
                  vm.patient = patient;
                  vm.newaide.patient = {};
                  vm.newaide.patient.svdata = vm.patient.svdata;
                  vm.newaide.patientid = vm.patient._id;
                  vm.newaide.patient._id = vm.patient._id;
                  vm.newaide.patient.primarycontact = vm.patient.primarycontact;
                }, function (err) {
                  $log.error('patient not found, id: ', vm.patientid, err);
                  Rlog.error('patdocs', 'newaide', 'client.$find() failed', {id: vm.patientid});
                });
              }
              if (angular.isDefined(changes.consultid)) {
                vm.consultid = changes.consultid.currentValue;
                if (angular.isUndefined(vm.newaide)) {
                  initNewRef();
                } else {
                  vm.newaide.consultid = vm.consultid;
                }
              }
            }
          };

          function setRefDate() {
            vm.newaide.refdate = moment().locale('de-at').format('ll');
          }

          function toggleGroup() {
            let tmpa = [];
            for (let i = 0; i < vm.aideconfig.groups.length; i++) {
              if (vm.newaide.ginclude[i] === true) {
                tmpa = tmpa.concat(vm.aideconfig.groups[i].values);
              }
            }
            vm.autoselectedvalues = uniq(flattenArray(tmpa));
            joinValues();
          }

          function joinValues() {
            let tmpa = [];
            if (angular.isArray(vm.autoselectedvalues) && angular.isArray(vm.newaide.additionalvalues)) {
              tmpa = vm.autoselectedvalues.concat(flattenArray(vm.newaide.additionalvalues));
            } else {
              if (angular.isArray(vm.autoselectedvalues)) {
                tmpa = vm.autoselectedvalues;
              }
              if (angular.isArray(vm.newaide.additionalvalues)) {
                tmpa = flattenArray(vm.newaide.additionalvalues);
              }
            }
            vm.newaide.allvalues = uniq(tmpa);
          }


          function flattenArray(a) {
            let tmpa = [];
            if (angular.isArray(a)) {
              for (let i = 0; i < a.length; i++) {
                tmpa.push(a[i].name);
              }
            }
            return tmpa;
          }

          // make array values uniq
          function uniq(a) {
            return a.sort().filter(function (item, pos, ary) {
              return !pos || item !== ary[pos - 1];
            });
          }

          // load and filter autocomplete values
          function loadValues($query) {
            // ngtags needs a promise as input
            let promise = new Promise(function (resolve, reject) {
              resolve(vm.aideconfig.values);
              reject();
            });
            return promise.then(function (values) {
              let filteredValues = values.filter(function (value) {
                return value.name.toLowerCase().indexOf($query.toLowerCase()) !== -1;
              });
              $log.debug('filtered values: ', filteredValues);
              return filteredValues;
            });
          }

          // reset ref form
          function initNewRef() {
            vm.newaide = {};
            vm.newaide.type = 'aide';
            vm.newaide.refdate = '';
            vm.newaide.ginclude = [];
            vm.newaide.additionalvalues = [];
            if (angular.isDefined(vm.consultid)) {
              vm.newaide.consultid = vm.consultid;
            }
            if (angular.isDefined(vm.patient)) {
              vm.newaide.patient = {};
              vm.newaide.patient.svdata = vm.patient.svdata;
              vm.newaide.patientid = vm.patient._id;
              vm.newaide.patient._id = vm.patient._id;
              vm.newaide.patient.primarycontact = vm.patient.primarycontact;
            }
          }

          // save referral doctor
          function saveDoctor(doctor) {
            delete vm.newaide.to;
            vm.newaide.doctor = doctor;
          }

          // clear referral doctor
          function clearDoctor() {
            delete vm.newaide.doctor;
          }


          // save patient data
          function savePatient(client, mode) {
            $log.debug('patient in savePAtient: ', client, mode);
            delete vm.newaide.patient;
            vm.patient = client;
            vm.patientid = client._id;
            vm.newaide.patient = {};
            vm.newaide.patient.fname = vm.patient.primarycontact.firstname + ' ' + vm.patient.primarycontact.lastname;
            vm.newaide.patient.svdata = vm.patient.svdata;
            vm.newaide.patientid = vm.patient._id;
            vm.newaide.patient._id = vm.patient._id;
            vm.newaide.patient.primarycontact = vm.patient.primarycontact;
          }

          // clear patient
          function clearPatient() {
            delete vm.newaide.patient;
            delete vm.newaide.patientid;
          }


          function add() {
            Patdocs.$create(vm.newaide).$then(function () {
              vm.saved = true;
              vm.savefailed = false;
              vm.canceled = false;
              initNewRef();
              $timeout(function () {
                vm.saved = false;
                if (angular.isDefined(vm.modal)) {
                  vm.modal.close();
                }
              }, 2000);
            }, (err => {
              vm.savefailed = true;
              $log.error('adding single aide failed: ', err);
              $timeout(function () {
                vm.savefailed = false;
              }, 3000);
            }));
          }

          function cancel() {
            vm.saved = false;
            vm.canceled = true;
            vm.savefailed = false;
            initNewRef();
            $timeout(function () {
              vm.canceled = false;
              if (angular.isDefined(vm.modal)) {
                vm.modal.close();
              }
            }, 1500);

          }

          function print() {
            Patdocs.$create(vm.newaide).$then(function (aide) {
              vm.saved = true;
              vm.savefailed = false;
              vm.canceled = false;
              $timeout(function () {
                vm.saved = false;
              }, 2000);
              initNewRef();
              $log.debug('aide returned: ', aide);
              PrintHelper.aideSinglePrint(aide._id, vm.patientid).then(function () {
                $log.debug('printing single aide succeeded');
                vm.printed = true;
                $timeout(function () {
                  delete vm.printed;
                }, 2000);
              }, function (err) {
                vm.printed = false;
                $timeout(function () {
                  delete vm.printed;
                }, 3000);
                $log.error('printing single aide failed: ', err);
              });

            });

          }


        }
      ] // controller
    }); // component

// klammerfriedhof
}());
